if (!customElements.get('ugc-media')) {
  class UgcMedia extends HTMLElement {
    constructor() {
      super();

      this.initSliderHandler = $(this.querySelector('.js-init-slider'));
    }

    initSlider() {
      $(this.initSliderHandler).slick({
        infinite: true,
        dots: false,
        arrows: false,
        adaptiveHeight: false,
        autoplay: this.dataset.autoplay === 'true' ? true : false,
        autoplaySpeed: +this.dataset.autoplaySpeed * 1000,
        centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]  
      });
    }

    connectedCallback() {
      this.initSlider();
    }

    disconnectedCallback() {
      this.querySelector('.js-init-slider').slick('destroy');
    }
  }

  customElements.define('ugc-media', UgcMedia);
}